<template>
  <v-container :fluid="true" class="bg-light-blue news">
    <div class="news__title--box">
      <span class="news__title">НОВОСТИ</span>
      <span
          v-if="$vuetify.display.width < 1920 && $vuetify.display.width > 960"
          class="more__title--link"
          @click="navigateTo()"
      >
        Посмотреть все
        <v-icon size="12" class="ml-5">$custom_arrow_sm</v-icon>
      </span>
    </div>
    <div class="news__content" v-if="!isLoadingNews && items.length > 0">
      <v-card
          v-for="item in items.slice(0, itemOnPage)"
          :key="item.title"
          class="news__card"
          elevation="0"
          rounded="0"
          @click="navigateTo(true, item.id)"
      >
        <v-img
            width="100%"
            :max-height="300"
            aspect-ratio="1"
            :src="getFileLink(item.image.link)"
            alt="news_photo"
        />
        <v-card-subtitle>
          <v-icon size="12" class="mr-5">$custom_arrow_sm</v-icon>
          <span v-if="item.category">{{ item.category }}</span>
          <span v-else>НОВОСТИ ПРОЕКТА</span>
        </v-card-subtitle>

        <v-card-text>
          <p>
            {{ item.theme }}
          </p>
        </v-card-text>
      </v-card>
      <div
          v-if="$vuetify.display.width <= 960"
          class="news__more"
          @click="navigateTo()"
      >
        посмотреть все
      </div>
    </div>
    <div v-else-if="!isLoadingNews && items.length === 0" style="background-color: white; border-radius: 10px">
      <NoData/>
    </div>
    <div v-else class="news__content">
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#34347C"
        />
      </v-row>
    </div>
    <div class="more__container" v-if="$vuetify.display.width >= 1920">
      <span
          class="more__title--link"
          @click="navigateTo()"
      >
        Посмотреть все
        <v-icon size="12" class="ml-5">$custom_arrow_sm</v-icon>
      </span>
    </div>

  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
// import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin"
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import helper from "@/urls/helper"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "News",
  components: { NoData, FulfillingSquareSpinner },
  data () {
    return {
    }
  },
  computed: {
    names: () => names,
    itemOnPage () {
      if (this.$vuetify.display.width < 1920 && this.$vuetify.display.width > 1440) {
        return 4
      } else {
        return 3
      }
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      items: 'personal_account/news/getNews',
      isLoadingNews: 'personal_account/news/isLoadingNews',
    }),
  },
  methods: {
    ...mapActions({
      loadNews: 'personal_account/news/loadNews',
    }),
    loadData (url = undefined) {
      this.loadNews({
        url: url,
        // urlAppend: (url) => {
        //   return this.addPageParameter(this.addSizeParameter(url))
        // },
        finalizer: () => {
          // this.setCurrentLoadUrl(url)
        },
        catcher: () => {}
      })
    },
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    navigateTo (detail = false, id = undefined) {
      if (detail) {
        window.location.href = process.env.VUE_APP_API_HOST.replace('api/', `news/${id}`)
      } else {
        window.location.href = process.env.VUE_APP_API_HOST.replace('api/', 'news')
      }
    },
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.news {
  padding: 50px 50px 50px 0;
}

.news__title--box {
  display: flex;
  justify-content: space-between;
}

.news__title {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.news__content {
  text-align: left;
  border-radius: 5px;
  width: 300px;
  background-color: white;
  padding: 30px 20px;
}

.v-card-subtitle {
  display: inline-flex;
  align-items: center;
  padding: 20px 0 0;
  max-width: 100%;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: #34347C;
  line-height: 17px;
  letter-spacing: .7px;
  opacity: 1;
}

.v-card-text {
  padding: 15px 0 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #313743;
}

.news__content > .v-card {
    padding-bottom: 25px;
    margin-bottom: 25px;
    border-bottom: 1px solid #D9D9D9;
    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
      border-bottom: none;
    }
}

.more__container {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.more__title--link {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  height: 30px;
  font-size: 14px;
  line-height: 17px;
  color: #3254B9;
  cursor: pointer;
}

.news__card {
  width: 260px;
}

.news__more {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  width: 152px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 0 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

@media screen and (max-width: 1919px) {
  .news__content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 30px;
  }

  .news__card {
    width: 340px !important;
    min-height: 270px;
    padding: 25px;
  }

  .news__content > .v-card {
    border-bottom: none;
    margin-bottom: 0;
    display: inline-block;

    &:last-child {
      padding-bottom: 25px;
    }
  }
}

@media screen and (max-width: 1560px) {
  .news__card {
    width: 320px !important;
  }
}

@media screen and (max-width: 1440px) {
  .news__card {
    width: 295px !important;
  }
}

@media screen and (max-width: 960px) {
  .news__content {
    position: relative;
  }
}

@media screen and (max-width: 768px) {
  .news {
    padding: 20px;
    margin-top: 20px;
  }

  .news__content {
    padding: 20px;
  }

  .news__card {
    width: 100% !important;
    padding: 0;
  }

  .news__content > .v-card {
    padding-bottom: 25px;
    margin-bottom: 25px;
    border-bottom: 1px solid #D9D9D9;
    &:last-child {
      border-bottom: none;
    }
  }

  .news__title {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .more__title--link {
    align-items: start;
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
